// extracted by mini-css-extract-plugin
module.exports = {"gutters":"ServerErrorPage_gutters__8kEyx","text":"ServerErrorPage_text__Ml1Yq","image":"ServerErrorPage_image__Zm9LX"};